import styled from "styled-components";
import React, {useEffect, useState} from "react";
import {ItemType, TypeOfItem} from "../../types";
import {motion} from "framer-motion";
import singleQubeImg from './../../assets/figures/single.png';
import doubleColQubeImg from './../../assets/figures/double_col.png';
import tripleColQubeImg from './../../assets/figures/triple_row_col.png';
import fourColQubeImg from './../../assets/figures/four_col_row.png';
import fiveColQubeImg from './../../assets/figures/five_row_col.png';
import miniAngleQubeImgLeftBottom from './../../assets/figures/mini_angle_left_bottom.png';
import miniAngleQubeImgLeftTop from './../../assets/figures/mini_angle_left_top.png';
import miniAngleQubeImgRightBottom from './../../assets/figures/mini_angle_right_bottom.png';
import miniAngleQubeImgRightTop from './../../assets/figures/mini_angle_right_top.png';
import angleQubeImgLeftBottom from './../../assets/figures/angle_left_bottom.png';
import angleQubeImgLeftTop from './../../assets/figures/angle_left_top.png';
import angleQubeImgRightBottom from './../../assets/figures/angle_right_bottom.png';
import angleQubeImgRightTop from './../../assets/figures/angle_right_top.png';
import doubleSquareQubeImg from './../../assets/figures/double_square.png';
import tripleSquareQubeImg from './../../assets/figures/triple_square.png';

export const BASE_ITEM_ANIMATION = 300;

export const typeQubes: { [key in TypeOfItem]: string } = {
    BOMB: '',

    SINGLE: singleQubeImg,

    DOUBLE_COL: doubleColQubeImg,
    TRIPLE_COL: tripleColQubeImg,
    FOUR_COL: fourColQubeImg,
    FIVE_COL: fiveColQubeImg,

    DOUBLE_ROW: doubleColQubeImg,
    TRIPLE_ROW: tripleColQubeImg,
    FOUR_ROW: fourColQubeImg,
    FIVE_ROW: fiveColQubeImg,

    DOUBLE_SQUARE: doubleSquareQubeImg,
    TRIPLE_SQUARE: tripleSquareQubeImg,

    MINI_ANGLE_LEFT_TOP: miniAngleQubeImgLeftTop,
    MINI_ANGLE_RIGHT_TOP: miniAngleQubeImgRightTop,
    MINI_ANGLE_RIGHT_BOTTOM: miniAngleQubeImgRightBottom,
    MINI_ANGLE_LEFT_BOTTOM: miniAngleQubeImgLeftBottom,

    ANGLE_LEFT_TOP: angleQubeImgLeftTop,
    ANGLE_LEFT_BOTTOM: angleQubeImgLeftBottom,
    ANGLE_RIGHT_BOTTOM: angleQubeImgRightBottom,
    ANGLE_RIGHT_TOP: angleQubeImgRightTop
}

const Root = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'typeOfItem',
})<{ size?: number; typeOfItem: TypeOfItem }>`
    height: ${({size}) => size}px;
    background-image: ${({typeOfItem}) => `url(${typeQubes[typeOfItem]})`};
    background-size: cover;
    background-repeat: no-repeat;
    width: ${({size}) => size}px;
`;

const RootGhost = styled(Root)`
    opacity: 0.5;
`;

interface Props {
    size: number;
    type?: ItemType;
    withAnimation?: boolean;
    isDisappearance?: boolean
    isDrag?: boolean;
    typeOfItem: TypeOfItem;
}

const bounceVariants = {
    appear: {
        scale: [1, 1.8, 1, 1.3, 1, 1.1, 1],
        transition: {
            duration: 0.6,
            ease: "easeOut",
        },
    },
    visible: {
        scale: [1, 1.2, 1],
        opacity: [0.5, 0.5, 1],
        transition: {
            duration: 0.3,
            ease: "easeOut",
        },
    },
    hidden: {
        scale: 0,
        opacity: 0,
        transition: {
            duration: 0.5,
            ease: "easeInOut",
        },
    },
};

export const BaseItem = ({typeOfItem, size, type, withAnimation = false, isDisappearance = false, isDrag}: Props) => {
    const [appear, setAppear] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setAppear(true);
        }, 0)
    }, [])


    switch (type) {
        case 'GHOST':
            return (
                <RootGhost typeOfItem={typeOfItem} size={size}/>
            );
        case 'VISIBLE':
            return (
                <motion.div
                    initial
                    animate={withAnimation && isDisappearance ? "hidden" : "visible"}
                    variants={bounceVariants}
                    style={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${typeQubes[typeOfItem]})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                    }}
                />
            );
        default:
            return (
                <motion.div
                    initial={false}
                    animate={withAnimation && isDisappearance ? "hidden" : appear ? 'appear' : "visible"}
                    variants={bounceVariants}
                    style={{
                        display: 'flex',
                        width: size,
                        height: size,
                        backgroundImage: `url(${typeQubes[typeOfItem]})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        border: isDisappearance ? '1px solid rgba(133, 116, 208, 0.5)' : 'none',
                    }}
                />
            );
    }
}